import { FinancialStatementItem } from '../../common/FinancialStatementItem';
import { FinancialStatementAccount } from '../../common/FinancialStatementAccount';
import { PartName } from '../../common/FinancialStatementPart';
export class FinancialStatementItemDTO {
  public constructor(
    public id?: number,
    public name?: string,
    public orderInTable?: number,
    public assetsAndLiabilities?: boolean,
    public partName?: PartName,
    public accountsIds?: number[],
  ) {}

  toEntity(accounts?: FinancialStatementAccount[]) {
    return new FinancialStatementItem(
      this.id,
      this.name,
      this.accountsIds.map((id) => accounts?.find((account) => account.id === id)),
      this.assetsAndLiabilities,
      this.partName,
      this.orderInTable,
    );
  }

  // this method is only used in itemAllocationMethod therefore there is no need to pass accountsIds
  static toEntity(itemDTO: FinancialStatementItemDTO): FinancialStatementItem {
    return new FinancialStatementItem(
      itemDTO.id,
      itemDTO.name,
      null,
      itemDTO.assetsAndLiabilities,
      itemDTO.partName,
    );
  }
}
